<template>
  <el-tooltip effect="dark" :content="message" placement="bottom" :disabled="type === 'text'">
      <button @click="click" :class="className" class="info" :aria-label="message">
          <i v-if="type === 'icon'" class="fas fa-pause"></i>
          <p v-else><i class="fas fa-pause"></i> {{ message }}</p>
      </button>
  </el-tooltip>
</template>

<script>
export default {
  name: "HoldButton",
  props : {
      type : {
          default : 'icon',
          required : false,
      },
      state: {
          type: Boolean,
          default: false,
          required: false
      }
  },
  data() {
      return {
          hold : false,
      }
  },
  methods : {
     click() {
          if (this.hold) {
            this.$emit('unhold')
          } else {
            this.$emit('hold')
          }
          this.hold = !this.hold
      }
  },
  computed : {
      message() {
          return (!this.hold) ? this.$t("call.hold") : this.$t("call.unhold")
      },
      className() {
          return {
              'text' : this.type === 'text',
              'is-holding': this.hold 
          }
      }
  },
  watch: {
      state(newState) {
        this.hold = newState;
      }
  },
  created() {
      this.hold = this.state;
  }
}
</script>

<style scoped>
  .is-holding {
      background: var(--blue-grey)!important;
      color: white!important;
  }
</style>